/**
 * @file OrderCancelDialog.tsx
 * @description Окно отмены заказа с обязательной причиной (phase19.31; было
 * `window.prompt("Причина отмены:")`).
 *
 * Раскладка и поведение — общее окно причины `ReasonDialog`; здесь только
 * тексты отмены и красная кнопка — действие опасное.
 */

import { ReasonDialog } from "./ReasonDialog";

interface Props {
  open: boolean;
  /** Номер заказа — в заголовке окна. */
  number: string;
  busy: boolean;
  onClose: () => void;
  /** Отменить с причиной; `true` — получилось, окно закрывается. */
  onConfirm: (reason: string) => Promise<boolean>;
}

export function OrderCancelDialog({ open, number, busy, onClose, onConfirm }: Props) {
  return (
    <ReasonDialog
      open={open}
      busy={busy}
      danger
      onClose={onClose}
      onConfirm={onConfirm}
      texts={{
        title: `Отменить заказ ${number}?`,
        description: "Заказ перейдёт в стадию «Отменён». Причина сохранится в карточке заказа.",
        label: "Причина отмены",
        placeholder: "Клиент передумал, товара нет в наличии…",
        confirm: "Отменить заказ",
        cancel: "Не отменять",
      }}
    />
  );
}
